import { useIntl } from 'react-intl';

import { ChatWindowProps } from '@verantos-dev/shared-components';

export interface UseFileUploadDragDropTextsParams {
  maxFileSizeMB?: number;
  accept?: string;
}

export const useFileUploadDragDropTexts = ({
  maxFileSizeMB = 10,
  accept = '.csv',
}: UseFileUploadDragDropTextsParams): ChatWindowProps['fileUploadDragDropTexts'] => {
  const intl = useIntl();
  const allowedFileTypes = accept?.split(',') ?? ['.csv'];

  return {
    dragRejectTitle: intl.formatMessage({
      id: 'projects.researchAssistant.chatWindow.fileUpload.dragRejectTitle',
    }),
    dragActiveTitle: intl.formatMessage({
      id: 'projects.researchAssistant.chatWindow.fileUpload.dragActiveTitle',
    }),
    dragRejectDescription: intl.formatMessage(
      {
        id: 'projects.researchAssistant.chatWindow.fileUpload.dragRejectDescription',
      },
      {
        allowedTypes: allowedFileTypes.join(', '),
        maxSizeMB: maxFileSizeMB,
      }
    ),
    dragActiveDescription: intl.formatMessage(
      {
        id: 'projects.researchAssistant.chatWindow.fileUpload.dragActiveDescription',
      },
      {
        allowedTypes: allowedFileTypes.join(', '),
        maxSizeMB: maxFileSizeMB,
      }
    ),
    fileTooLarge: intl.formatMessage(
      {
        id: 'projects.researchAssistant.chatWindow.fileUpload.fileTooLarge',
      },
      {
        maxSizeMB: maxFileSizeMB,
      }
    ),
    invalidFileType: intl.formatMessage(
      {
        id: 'projects.researchAssistant.chatWindow.fileUpload.invalidFileType',
      },
      {
        allowedTypes: allowedFileTypes.join(', '),
      }
    ),
    uploadFailed: intl.formatMessage({
      id: 'projects.researchAssistant.chatWindow.fileUpload.uploadFailed',
    }),
  };
};
